export const media = {
    monitor: '@media all and (max-width: 2560px)',
    large_desktop: '@media all and (max-width: 1680px)',
    desktop: '@media all and (max-width: 1440px)',
    laptop: '@media all and (max-width: 1024px)',
    tablet: '@media all and (max-width: 768px)',
    mobile: '@media all and (max-width: 425px)',
}